// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Box, Button, Flex, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Dialog, Icon, Lottie, Tag } from "components"

// Hooks
import { useOrder } from "hooks"
import { API } from "config"
import { useQueryClient } from "@tanstack/react-query"
import { Enums } from "config"

export default function Montage({ data, step, setStep }){

    const order = useOrder(data?.id)
    const confirm = useDisclosure()
    const forShipping = order.data?.shipping_type === Enums.OrderShippingType.SHIPPING

    return(
    <>
    <Flex maxW="40%" justifyContent="center" alignItems="center" direction="column" margin="30px auto">
        <Lottie animation="montage" options={{ loop: true }} style={{ width: 200 }} />
        <Text fontSize="lg" fontWeight="bold" children="Pedido sendo montado..." />
        <Text textAlign="center" color="GrayText">O pedido está sendo montado no momento. Quanto todos os itens do pedido estiverem embalados, prossiga para a <b>Cotação</b>.</Text>
        <Button children={forShipping ? 'Continuar para cotação' : 'Continuar para fiscal'} mt={4} rightIcon={<Icon name="right" />} colorScheme="orange" onClick={confirm.onOpen} isDisabled={order?.isFetching}  />
    </Flex>

    {/* Confirm */}
    <ConfirmAlert {...confirm} data={order.data} onSuccess={order.refetch} />
    </>
    )
}

const ConfirmAlert = ({ data, onSuccess = () => {}, ...props }) => {

    const toast = useToast()
    const queryClient = useQueryClient()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!window.confirm('Certeza que deseja continuar?')) return
        setLoading(true)
        
        try{
            await API.put(`/orders/${data?.id}/montage/finish`)
            toast({ title: 'O pedido agora está em cotação', status: 'success' })
            queryClient.invalidateQueries('w-orders')
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível iniciar a montagem.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Dialog loading={loading} title={`Concluir montagem do pedido #${data?.cod}?`} {...props}>
        <AlertDialogBody fontSize="sm">
            Garanta que todos os itens do pedido estejam embalados antes de prosseguir.
        </AlertDialogBody>
        <AlertDialogFooter>
            <Button w="100%" children="Concluir Montagem" colorScheme="orange" rightIcon={<Icon name="right" />} isLoading={loading} onClick={handleSubmit} />
        </AlertDialogFooter>
    </Dialog>
    )
}